import { MultilingualLanguages } from '@asgard/api-common';
import JobOfferComponent from 'components/jobOffer/JobOfferComponent';
import JobOfferPageHead from 'components/jobOffer/JobOfferPageHead';
import WIPFeaturesContext from 'context/wip-features/wip-features.context';
import { WebOffer } from 'model/model.web-offer';
import { GetServerSideProps } from 'next';
import absoluteUrl from 'next-absolute-url';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/dist/client/router';
import { DEFAULT_LOCALE } from 'services/multilingual.service';
import { ServiceWebOffer } from 'services/service.web-offer';
import { APP_URLS, getNotFoundUrl, getSSRRedirectionTo } from 'utils/app-urls';

type OfferViewProps = {
  offer: WebOffer;
  origin: string;
};

export default function OfferView({ offer, origin }: OfferViewProps) {
  const router = useRouter();

  return (
    <>
      <JobOfferPageHead
        preview={true}
        url={APP_URLS.jobOffer}
        offer={offer}
        locale={router.locale}
        origin={origin}
      />
      <WIPFeaturesContext.Provider value={false}>
        <JobOfferComponent offer={offer} origin={origin} />
      </WIPFeaturesContext.Provider>
    </>
  );
}

export const getServerSideProps: GetServerSideProps<OfferViewProps> = async (
  context
) => {
  if (!context.params || !context.params.id || !context.params.previewId) {
    return getSSRRedirectionTo(getNotFoundUrl(context.locale));
  }

  const offer = await ServiceWebOffer.getByPreviewId(
    context.params.previewId.toString(),
    context.params.id.toString(),
    context.locale?.toUpperCase() as MultilingualLanguages,
    'public-endpoint'
  );

  const { origin } = absoluteUrl(context.req);

  return {
    props: {
      offer: JSON.parse(JSON.stringify(offer)),
      origin,
      ...(await serverSideTranslations(context.locale || DEFAULT_LOCALE, [
        'common',
        'job-offer',
        'apply-modal',
        'topbar',
        'footer'
      ]))
    }
  };
};
